type KnownWeatherClasses =
  | 'weathersunny'
  | 'weathercloudy'
  | 'weathercloudypartly'
  | 'weatherraining'
type UnknownWeatherClass = 'weatherunknown'

export type WeatherClass = KnownWeatherClasses | UnknownWeatherClass

type WeatherClassMap = Record<KnownWeatherClasses, string[]>

export const WeatherClassUtil: {
  classes: WeatherClassMap
  defaultClass: UnknownWeatherClass
  getClassForWeather(Weather: string): string
} = {
  classes: {
    weathersunny: ['sunny', 'clear', 'good', 'fine'],

    weathercloudy: ['cloudy', 'cloud'],

    weathercloudypartly: ['overcast', 'average'],

    weatherraining: [
      'rain',
      'rainy',
      'raining',
      'drizzle',
      'storm',
      'stormy',
      'awful',
      'bad',
      'showery',
      'showers',
    ],
  },

  defaultClass: 'weatherunknown',

  getClassForWeather(Weather) {
    Weather = Weather.toLowerCase()

    for (const weatherClass in WeatherClassUtil.classes) {
      if (WeatherClassUtil.classes[weatherClass as KnownWeatherClasses].indexOf(Weather) !== -1) {
        return weatherClass
      }
    }

    return WeatherClassUtil.defaultClass
  },
} as const
